const binding = { modules: {}, dataActions: {} };

    (binding.modules['defa-action-tile'] = {
        c: () => require('partner/modules/defa-action-tile/defa-action-tile.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'defa-action-tile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/defa-action-tile'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|defa-action-tile|defa-action-tile'] = {
                c: () => require('partner/modules/defa-action-tile/defa-action-tile.view.tsx'),
                cn: '__local__-__local__-defa-action-tile'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };